import { ts } from 'src/utils/translate';

export const IncludeLayer = (props: any) => {
  const { floorWiringSvgObject, includeLayer, setIncludeLayer } = props;

  const uniqueId = `chk_${floorWiringSvgObject.wiringType}_${floorWiringSvgObject.floorId}`;

  return (
    <div className="remove-on-export">
      <input
        id={uniqueId}
        type="checkbox"
        checked={includeLayer}
        onChange={(e) => setIncludeLayer(e.target.checked)}
      ></input>
      <label
        htmlFor={uniqueId}
        style={{ marginLeft: 5, fontSize: "1.5em", userSelect: "none" }}
      >
        {ts("docu_include_page", "Include page")}
      </label>
    </div>
  );
};
